import React, { Component } from "react";

import { Formik, Field } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Input } from "../../../../_metronic/_partials/controls";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import firebase from "../../../../firebaseConfig";
import { Modal, } from 'react-bootstrap'

// TODO: Rewrite to pure function
class ForgotPassword extends Component {
    state = { isRequested: false,isShow:false };

    render() {
        const { intl } = this.props;
        const { isRequested } = this.state;

        if (isRequested) {
            return <Redirect to="/auth" />;
        }

        const getInputClasses = (meta, fieldname) => {
            let result = "form-control form-control-solid h-auto py-5 px-6 ";
            if (meta.touched && meta.error) {
                result += " is-invalid"
            }

            if (meta.touched && !meta.error) {
                result += " is-valid"
            }

            return result;
        }

        return (
            <div className="login-form">
                <div className="text-center mb-10 mb-lg-20">
                    <h3 className="font-size-h1">Forgot Password</h3>
                </div>

                <Formik
                    initialValues={{ email: "" }}
                    validate={values => {
                        const errors = {};

                        if (!values.email) {
                            errors.email = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                        ) {
                            errors.email = intl.formatMessage({
                                id: "AUTH.VALIDATION.INVALID_FIELD"
                            });
                        }

                        return errors;
                    }}
                    onSubmit={(values, { setStatus, setSubmitting }) => {
                        // requestPassword(values.email)
                        //     .then(() => {
                        //         this.setState({isRequested: true});
                        //     })
                        //     .catch(() => {
                        //         setSubmitting(false);
                        //         setStatus(
                        //             intl.formatMessage(
                        //                 {id: "AUTH.VALIDATION.NOT_FOUND"},
                        //                 {name: values.email}
                        //             )
                        //         );
                        //     });

                        firebase.auth().sendPasswordResetEmail(values.email)
                            .then(user => {
                                this.setState({ isShow: true });
                                // setStatus(
                                //                         intl.formatMessage(
                                //                             {id: "AUTH.VALIDATION.MessageDescriptor"},
                                //                             {MSG:'Please check your email for resetting your password'}
                                //                         )
                                //                     );

                            }).catch(error => {

                                setSubmitting(false);
                                setStatus(
                                    intl.formatMessage(
                                        { id: "AUTH.VALIDATION.NOT_FOUND" },
                                        { name: values.email }
                                    )
                                );
                            })





                    }}
                >
                    {({
                        values,
                        status,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <form onSubmit={handleSubmit} className="form">
                            {status && (
                                <div role="alert" className="alert alert-danger">
                                    <div className="alert-text">{status}</div>
                                </div>
                            )}

                            <div className="form-group">
                                <Field
                                    type="email"
                                    name="email"
                                    component={Input}
                                    placeholder="Email"
                                    label="Email"
                                >

                                    {({ field, form, meta }) => (
                                        <div>
                                            <input
                                                type="email" {...field}
                                                className={`${getInputClasses(meta)}`}
                                                placeholder="Enter Email" />
                                            {meta.touched &&
                                                meta.error && <div className="error invalid-feedback">{meta.error}</div>}
                                        </div>
                                    )}
                                </Field>
                            </div>

                            <div className="form-group d-flex flex-wrap flex-center">
                                <button
                                    id="kt_login_forgot_submit"
                                    type="submit"
                                    className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                                    disabled={isSubmitting}
                                >
                                    Submit
                                </button>
                                <Link to="/auth">
                                    <button
                                        type="button"
                                        id="kt_login_forgot_cancel"
                                        className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                                    >
                                        Cancel
                                    </button>
                                </Link>
                            </div>
                        </form>
                    )}
                </Formik>
                <Modal centered size="md" show={this.state.isShow} onHide={()=> this.setState({ isRequested: true })}>
                    <Modal.Header closeButton style={{display:"block",textAlign:"center"}}>
                        <Modal.Title id="example-modal-sizes-title-lg text-center">Email Sent</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-0 pb-0">
                        <div className="row p-5" style={{display:"block",textAlign:"center"}}>
                        <p className="m-0 text-center">Please check your email for resetting your password </p>
                        </div>
                        <div className="form-group row" style={{display:"block",textAlign:"center"}}>
                        <div className="col-md-12 mb-5">
                            <button type="button" onClick={()=> this.setState({ isRequested: true })} className="btn btn-light mw-6" >Ok </button>
                        </div>
                        </div>
                    </Modal.Body>
                </Modal>
                
            </div>
            
        );
    }
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
